module.exports = __webpack_public_path__ + "static/media/heroes&green-heroes.34c98614.png";